import formatRelative from "date-fns/formatRelative";
import isToday from "date-fns/isToday";
import isTomorrow from "date-fns/isTomorrow";
import isYesterday from "date-fns/isYesterday";
import { ru } from "date-fns/locale";

export namespace Dates {
  export const relative = (date: Date) => {
    switch (true) {
      case isYesterday(date):
        return "Вчера";

      case isToday(date):
        return "Сегодня";

      case isTomorrow(date):
        return "Завтра";

      default:
        return formatRelative(date, new Date(), {
          locale: {
            ...ru,
            formatRelative: (token) => {
              return (
                {
                  lastWeek: "dd.MM.yyyy",
                  yesterday: "'Вчера'",
                  today: "'Сегодня'",
                  tomorrow: "'Завтра'",
                  nextWeek: "dd.MM.yyyy",
                  other: "dd.MM.yyyy",
                } as { [key: string]: string }
              )[token];
            },
          },
        });
    }
  };
}
